import {configureStore} from '@reduxjs/toolkit';
import {reducer as user} from '~/common/fabric/User/reducers/user';
import {promiseResolverMiddleware} from '~/common/middleware/promiseResolver';
import {reducer as loginModal} from '~library/organisms/LoginModal/reducer';

export const reducers = {
  loginModal,
  user,
};
export const middlewares = (getDefaultMiddleware) =>
  getDefaultMiddleware({
    immutableCheck: false,
    serializableCheck: false,
  }).concat(promiseResolverMiddleware);

export const store = configureStore({
  reducer: reducers,
  middleware: middlewares,
});
